var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"sb_background",class:{ 's_in-focus-mode': _vm.focusMode }},[(!_vm.focusMode)?_c('div',{staticClass:"sb_background_image-bg",style:(Object.assign({}, {transform: 'translate(-50%, -50% ) scale(' + _vm.scale + ')'},
      (_vm.backgroundImage
        ? { 'background-image': ("url(" + _vm.backgroundImage + ")") }
        : {}),
      {opacity: _vm.backgroundOpacity}))}):_vm._e()])}
var staticRenderFns = []

export { render, staticRenderFns }